import config from 'config'
import { user } from 'ampersand-app'

const { resourceHost } = config
export const OCRService = {
  analyze: (blob) => {
    return new Promise((resolve, reject) => {
      const fd = new FormData()
      fd.append('image', blob)

      const request = new Request(`${resourceHost}ocr/analyze`, {
        headers: {
          authorization: `Bearer ${user.token}`,
        },
        method: 'POST',
        body: fd,
      })

      return fetch(request)
        .then((res) => res.json())
        .then((res) => resolve(res.data))
        .catch(e => reject(e))
    })
  },
}
